import {Injectable} from '@angular/core';
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular'
import Bugsnag, {Event} from "@bugsnag/js";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerFactory {

  private missingChunkHandler (error: Event): boolean {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(error.errors[0].errorMessage)) {
      window.location.reload();
    }

    return false;
  }

  private networkErrorHandler (error: Event): boolean {
    if (['401', '403', '404'].includes(error.errors[0].type)) {
      console.error(error.errors[0].errorMessage);
      return false;
    }

    return true;
  }

  get(): BugsnagErrorHandler {
    const apiKeyOrOpts = {
      apiKey: environment.bugsnagKey,
      releaseStage: location.hostname === 'app.getdialog.nl' ? 'production' : 'development'
    };
    const client = Bugsnag.createClient(apiKeyOrOpts);
    client.addOnError(this.missingChunkHandler);
    client.addOnError(this.networkErrorHandler);

    Bugsnag.start(apiKeyOrOpts);

    return new BugsnagErrorHandler(client);
  }
}
